/* eslint-disable camelcase */
import ColorHash from 'color-hash';
// import Prism from 'prismjs';
import { element } from 'angular';
import { nanoid } from 'nanoid';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';

/* globals Knitiv */

const colorHash = new ColorHash();

export default class {
	/* @ngInject */
	/**
	 * @param {import('angular').route.IRouteParamsService} $routeParams
	 * @param {import('angular').IQService} $q
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} Notification
	 */
	constructor($routeParams, $q, $rootScope, Notification) {
		/** @type {string} */
		this.value = '';

		/** @type {import('@knitiv/api-client-javascript').APIDefinition | null} */
		this.api = null;

		/** @type {string} */
		this.endpoint = `${APIV5.instance.backEndpoint}/api/v${Defaults.api.version}`;

		/** @type {Array<string>} */
		this.items = [];

		/** @type {string} */
		this.headerTokenName = Defaults.api.headerTokenName;

		this.headers = [
			{
				text: 'Nom du paramètre',
				value: 'name',
			},
			{
				text: 'Description',
				value: 'description',
			},
			{
				text: 'Requis',
				value: 'required',
				align: 'center',
			},
			{
				text: 'Valeur par défaut',
				value: 'default',
			},
			{
				text: 'Type',
				value: 'type',
				align: 'center',
			},
		];

		/** @type {boolean} */
		this.isLoading = true;

		/** @type {string} */
		this.lang = 'fr';

		/** @type {any} */
		this.request = {};

		/** @type {any} */
		this.requestResult = {};

		/** @type {string} */
		this.tab = 'doc';
		this.tokens = [
			{
				name: $rootScope.context?.profil.name,
				token: $rootScope.context?.token.id,
			},
		];
		this.selectedToken = this.tokens[0];

		this.options = {
			mode: 'form',
			modes: ['tree', 'form', 'view', 'code'],
		};
		this.optionsResult = {
			mode: 'view',
			modes: ['view', 'code'],
		};

		/** @type {any} */
		this.structure = {};

		this.slots = [
			'header',
			'input',
			'output',
		];

		this.$routeParams = $routeParams;
		this.$q = $q;
		this.$rootScope = $rootScope;
		this.Notification = Notification;

		// Workaround to trigger $onInit for components on routes
		element(() => this.$onInit());
	}

	async $onInit() {
		const { api, tab } = this.$routeParams;

		if (api) {
			// set input
			this.value = api;
			// fetch api
			this.onApiChange(api);
		}

		if (tab) {
			this.tab = tab;
		}

		const { result } = await APIV5.instance.uiGetContent({
			path: 'LANG',
		}, { id: 'help' });
		const match = Object.values(result).find(r => 'kid' in r && r.kid === this.$rootScope?.appConfig.lang.kid);
		if (match && 'code' in match) {
			this.lang = match.code;
		}
		const apiList = await APIV5.instance.apiList({ id: 'help.init' });

		return this.$q
			.resolve(apiList)
			.then(({ list }) => {
				this.items = list.map(item => item.name).sort();
				this.isLoading = false;

				// Prism.highlightAll(false, _element => console.log(_element));
				return true;
			});
	}

	/**
	 *
	 * @param {any} json Objet à traiter
	 * @returns {string} Résultat
	 */
	// eslint-disable-next-line class-methods-use-this
	escapeQuotes(json) {
		return JSON.stringify(json).replaceAll('"', '\\"');
	}

	/**
	 *
	 * @param {Array<import('@knitiv/api-client-javascript').ItemDefinition>} rootItems
	 * @param {'or' | null} type
	 * @param {number} deep
	 * @returns {Array<import('@knitiv/api-client-javascript').ItemDefinition>}
	 */
	flattenObject(rootItems, type = null, deep = 0) {
		// console.log('root', rootItems);
		/** @type {Array<import('@knitiv/api-client-javascript').ItemDefinition>} */
		const result = [];
		for (const itemDefinition of rootItems) {
			/** @type {any} */
			const item = { ...itemDefinition };
			item.uid = nanoid();
			item.level = deep;
			item.name = type === 'or' ? `${'\t'.repeat(deep)}→ ou` : `${'\t'.repeat(deep)}${item.name}`;
			result.push(item);

			if (item.type === 'object') {
				let { items } = item;
				if (items) {
					items = items.map((
						/** @type {string | import("@knitiv/api-client-javascript").ItemDefinitionExt} */ index,
					) => {
						if (this.isReference(index)) {
							return this.resolve(index);
						}
						return index;
					});
					result.push(...this.flattenObject(items, null, deep + 1));
				}
			}

			if (item.type === 'dictionary') {
				const { type_detail } = item;
				if (type_detail && this.isReference(type_detail.key)) {
					result.push(...this.flattenObject([this.resolve(type_detail.key)], null, deep + 1));
				}
				if (type_detail && this.isReference(type_detail.value)) {
					result.push(...this.flattenObject([this.resolve(type_detail.value)], null, deep + 1));
				}
			}

			if (item.type === 'array') {
				const { type_detail } = item;
				if (type_detail && this.isReference(type_detail.of)) {
					result.push(...this.flattenObject([this.resolve(type_detail.of)], null, deep + 1));
				}
			}

			if (item.type === '_values_') {
				const { type_detail } = item;
				if (type_detail) {
					const { values: _values } = type_detail;
					/** @type {string[]} */
					const values = _values;

					const possibleValues = values.map(
						/**
						 * @param {any} vType
						 * @returns {import('@knitiv/api-client-javascript').ItemDefinition}
						 */
						vType => {
							if (typeof vType === 'string') {
								if (this.isReference(vType)) {
									return this.resolve(vType);
								}
								return ({
									default: undefined,
									description: {},
									required: false,
									type: vType,
									name: '',
								});
							}
							return vType;
						},
					);

					result.push(...this.flattenObject(possibleValues, 'or', deep + 1));
				}
			}
		}
		return result;
	}

	// eslint-disable-next-line class-methods-use-this
	generateSchema() {
		// TODO https://github.com/fastify/fluent-schema
		return {};
	}

	/**
	 * @param {string} type
	 * @returns {string}
	 */
	// eslint-disable-next-line class-methods-use-this
	getChipBg(type) {
		return colorHash.hex(type);
	}

	// eslint-disable-next-line class-methods-use-this
	/**
	 * @param {string | string[] | import('@knitiv/api-client-javascript').ItemDefinitionExt} string
	 * @returns {boolean}
	 */
	isReference(string) {
		return typeof string === 'string' && string[0] === '$';
	}

	/**
	 *
	 * @param {import('@knitiv/api-client-javascript').ItemDefinition} item
	 * @returns {string}
	 */
	// eslint-disable-next-line class-methods-use-this
	makeTypeString(item) {
		let finalString = item.type.toString();
		switch (item.type) {
		case 'dictionary': {
			const details = item.type_detail;
			if (this.isReference(details.key)) {
				const { name } = this.resolve(details.key);
				if (name) {
					details.key = name.replace('<', '').replace('>', '');
				}
			}
			if (this.isReference(details.value)) {
				const { name } = this.resolve(details.value);
				if (name) {
					details.value = name.replace('<', '').replace('>', '');
				}
			}
			finalString += `<${details.key}, ${details.value}>`;

			break;
		}
		case 'array': {
			let { of } = item.type_detail;
			if (this.isReference(of)) {
				const { name } = this.resolve(of);
				if (name) {
					of = name.replace('<', '').replace('>', '');
				}
			}
			finalString += `<${of}>`;

			break;
		}
		case '_values_': {
			finalString = 'multiple';

			break;
		}
		default: { if (item?.type_detail?.items) {
			finalString = item.type_detail.items.join(' | ');
		}
		}
		}
		return finalString;
	}

	/**
	 *
	 * @param {string} api
	 */
	async onApiChange(api) {
		this.isLoading = true;
		this.request = {};
		this.requestResult = {};
		return this.$q.when(APIV5.instance.help({
			api,
		})).then(response => {
			this.api = response.api;

			// eslint-disable-next-line no-underscore-dangle
			for (const _slot of this.slots) {
				const slot = _slot;
				if (this.api) {
					// @ts-ignore
					const flat = this.flattenObject(this.api[slot]);
					this.structure[slot] = flat;
				}
			}
			// console.log('this.structure', this.structure);

			// Fill in the playground part
			for (const data of this.structure.input) {
				if (data.required && data.level === 0) {
					this.request[data.name] = data.default ?? '';
				}
			}

			// this.options.schema = this.generateSchema(this.request.input);

			this.isLoading = false;
			return true;
		});
	}

	/**
	 *
	 * @param {string | import('@knitiv/api-client-javascript').ItemDefinition} temporaryItem
	 * @returns {import('@knitiv/api-client-javascript').ItemDefinition}
	 */
	resolve(temporaryItem) {
		const result = this.isReference(temporaryItem)
			// @ts-ignore
			? this.api.references[temporaryItem]
			: temporaryItem;
		return result;
	}

	sendRequest() {
		this.$q
			.when(
				APIV5.instance.raw(this.value, this.request, {
					headers: {
						[Defaults.api.headerTokenName]: this.selectedToken.token || '',
					},
				}),
			)
			.then(result => {
				if (this.value === 'Login' && this.tokens.filter(x => x.token === result.token.id).length === 0) {
					this.tokens.push({
						name: result.profil.name,
						token: result.token.id,
					});
					this.Notification.info({
						title: 'Token ajouté avec succès',
						message: `Le token de l'utilisateur ${result.profil.name} a bien été ajouté a la liste`,
					});
				}

				this.requestResult = result;
				return result;
			})
			.catch(/** @param {Error} error The error from the API */error => {
				this.requestResult = {
					error: 'Veuillez consulter la console pour obtenir plus de détails',
					description: error.message,
				};
			});
	}
}
